import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Lock = ({
  size,
  type,
  theme,
  className,
  dataTestId = "lock-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M8.66679 9.54548C8.66679 9.17729 8.36831 8.87882 8.00012 8.87882C7.63193 8.87882 7.33346 9.17729 7.33346 9.54548V12.0668C7.33346 12.435 7.63193 12.7334 8.00012 12.7334C8.36831 12.7334 8.66679 12.435 8.66679 12.0668V9.54548Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.5509 5.84887H3.88684V2.90573C3.88684 1.43297 5.08075 0.239059 6.55351 0.239059H9.4436C10.9164 0.239059 12.1103 1.43297 12.1103 2.90573V5.84887H12.4489C13.5535 5.84887 14.4489 6.7443 14.4489 7.84887V13.7624C14.4489 14.867 13.5535 15.7624 12.4489 15.7624H3.5509C2.44633 15.7624 1.5509 14.867 1.5509 13.7624V7.84887C1.5509 6.7443 2.44633 5.84887 3.5509 5.84887ZM10.7769 5.84887H5.22017V2.90573C5.22017 2.16935 5.81713 1.57239 6.55351 1.57239H9.4436C10.18 1.57239 10.7769 2.16935 10.7769 2.90573V5.84887ZM3.5509 7.1822C3.18271 7.1822 2.88424 7.48068 2.88424 7.84887V13.7624C2.88424 14.1306 3.18271 14.4291 3.5509 14.4291H12.4489C12.8171 14.4291 13.1156 14.1306 13.1156 13.7624V7.84887C13.1156 7.48068 12.8171 7.1822 12.4489 7.1822H3.5509Z"
    />
  </SVGIcon>
);
